module.exports = __webpack_public_path__ + "img/feather.a6cab908.svg";